import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { DateFnsModule } from 'ngx-date-fns';

@Component({
  selector: 'lib-freight-carrier-inprogress-card-schedule',
  templateUrl: './freight-carrier-inprogress-card-schedule.component.html',
  styleUrls: ['./freight-carrier-inprogress-card-schedule.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonIcon, DateFnsModule],
})
export class FreightCarrierInprogressCardScheduleComponent {
  readonly since = input.required<Date | null>();

  readonly until = input.required<Date | null>();

  // constructor() {}
}
